(function () {
  if (window.__cappyrootsFocus3PackRuntime) return;
  window.__cappyrootsFocus3PackRuntime = true;

  var doc = document;
  var vipProductDiscount = 'VIPFOCUS3';
  var vipShippingDiscount = 'VIP3SHIP';
  var vipDrawerPendingKey = 'crVip3PackDrawerPending';
  function readVipDrawerPending() {
    try { return window.sessionStorage.getItem(vipDrawerPendingKey) || ''; } catch (error) { return ''; }
  }
  function writeVipDrawerPending(step) {
    try { window.sessionStorage.setItem(vipDrawerPendingKey, step); } catch (error) {}
  }
  function clearVipDrawerPending() {
    try { window.sessionStorage.removeItem(vipDrawerPendingKey); } catch (error) {}
  }
  function request(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }
  function add(variantId, quantity) {
    return request('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) }] })
    });
  }
  function updateHeaderCount(cart) {
    var count = Math.max(0, Number(cart && cart.item_count) || 0);
    doc.querySelectorAll('.cr-iconbtn__count[data-cr-cart-count]').forEach(function (node) {
      node.textContent = String(count);
      node.hidden = count === 0;
    });
  }
  function refreshDrawer(cart) {
    var drawer = doc.getElementById('CrCartDrawer');
    var section = drawer && drawer.closest('.shopify-section');
    var sectionId = section && section.id ? section.id.replace(/^shopify-section-/, '') : '';
    if (!sectionId) {
      updateHeaderCount(cart);
      return Promise.resolve();
    }
    var url = new URL(window.location.href);
    url.searchParams.set('sections', sectionId);
    url.hash = '';
    return fetch(url.pathname + url.search, { cache: 'no-store' })
      .then(function (response) { if (!response.ok) throw new Error('Cart refresh failed'); return response.json(); })
      .then(function (sections) {
        var html = sections[sectionId];
        if (html && drawer) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-cr-drawer-content]');
          var current = drawer.querySelector('[data-cr-drawer-content]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
        updateHeaderCount(cart);
      });
  }
  function openDrawer() {
    var drawer = doc.getElementById('CrCartDrawer');
    if (!drawer) return false;
    try {
      if (!drawer.open) {
        if (typeof drawer.showModal === 'function') drawer.showModal();
        else drawer.setAttribute('open', '');
      }
    } catch (error) {
      drawer.setAttribute('open', '');
    }
    var root = doc.documentElement;
    if (root && root.getAttribute('data-cr-scroll-locked') !== '1') {
      var gap = Math.max(0, window.innerWidth - root.clientWidth);
      root.setAttribute('data-cr-scroll-locked', '1');
      root.setAttribute('data-cr-prev-pad', root.style.paddingRight || '');
      root.style.overflow = 'hidden';
      if (gap) root.style.paddingRight = gap + 'px';
    }
    var focus = drawer.querySelector('[data-cr-drawer-focus], [data-cr-close], button, a[href]');
    if (focus) window.setTimeout(function () { try { focus.focus({ preventScroll: true }); } catch (error) { focus.focus(); } }, 60);
    return true;
  }
  function openDrawerReliably() {
    var attempts = 0;
    function attempt() {
      if (openDrawer() || attempts >= 12) return;
      attempts += 1;
      window.setTimeout(attempt, 75);
    }
    window.setTimeout(attempt, 40);
  }
  function toast(message) {
    var node = doc.querySelector('[data-cr-focus3p-status]');
    if (!node) return;
    node.textContent = message;
    node.classList.add('is-visible');
    window.clearTimeout(toast.timer);
    toast.timer = window.setTimeout(function () { node.classList.remove('is-visible'); }, 3200);
  }
  function setBusy(button, busy, idleLabel) {
    if (!button) return;
    button.disabled = busy;
    if (busy) {
      button.setAttribute('data-cr-idle-html', button.innerHTML);
      button.textContent = 'Adding your 3-Pack…';
    } else {
      button.innerHTML = idleLabel || button.getAttribute('data-cr-idle-html') || 'Add the VIP 3-Pack';
    }
  }
  function pathForVipStep(step) {
    var url = new URL(window.location.href);
    url.searchParams.set('cr-vip-step', step);
    url.hash = '';
    return url.pathname + url.search;
  }
  function beginVipDiscountRedirect() {
    // Shopify can normalize a discount redirect without preserving custom query parameters.
    // Keep the intended stage in session storage so the drawer still opens after both approved codes apply.
    writeVipDrawerPending('product');
    var returnPath = pathForVipStep('shipping');
    window.location.assign('/discount/' + encodeURIComponent(vipProductDiscount) + '?redirect=' + encodeURIComponent(returnPath));
  }
  function markVipCartConfirmation(drawer) {
    var vipLine = drawer && drawer.querySelector('[data-cr-vip-cart-line]');
    if (vipLine) vipLine.classList.add('is-confirmed');
  }
  function markVipShippingActive() {
    var drawer = doc.getElementById('CrCartDrawer');
    var meter = drawer && drawer.querySelector('[data-cr-shipmeter]');
    markVipCartConfirmation(drawer);
    if (!meter) return;
    meter.classList.add('cr-shipmeter--vip', 'cr-shipmeter--unlocked');
    meter.setAttribute('data-cr-ship-state', 'vip');
    meter.setAttribute('data-cr-ship-pct', '100');
    var title = meter.querySelector('.cr-shipmeter__title');
    var message = meter.querySelector('[data-cr-ship-msg]');
    var track = meter.querySelector('.cr-shipmeter__track');
    var fill = meter.querySelector('.cr-shipmeter__fill');
    if (title) title.textContent = 'Free shipping activated';
    if (message) message.textContent = 'Included with your VIP 3-Pack.';
    if (track) { track.setAttribute('aria-valuenow', '100'); track.setAttribute('aria-label', 'VIP 3-Pack free shipping activated'); }
    if (fill) fill.style.width = '100%';
    var copy = meter.querySelector('.cr-shipmeter__text');
    var sub = meter.querySelector('.cr-shipmeter__submsg');
    if (!sub && copy) { sub = doc.createElement('p'); sub.className = 'cr-shipmeter__submsg'; copy.appendChild(sub); }
    if (sub) sub.remove();
    if (track && !track.querySelector('.cr-shipmeter__goal')) {
      var goal = doc.createElement('span'); goal.className = 'cr-shipmeter__goal'; goal.setAttribute('aria-hidden', 'true');
      goal.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';
      track.appendChild(goal);
    }
  }
  function openCompletedVipDrawer() {
    var url = new URL(window.location.href);
    url.searchParams.delete('cr-vip-step');
    window.history.replaceState({}, '', url.pathname + (url.search || '') + url.hash);
    clearVipDrawerPending();
    markVipShippingActive();
    // Run once as soon as this deferred asset is ready and once after the drawer section finishes any theme refresh.
    openDrawerReliably();
    window.setTimeout(openDrawerReliably, 320);
    return true;
  }
  function applyVipShippingCode() {
    writeVipDrawerPending('shipping');
    var returnPath = pathForVipStep('open-drawer');
    window.location.replace('/discount/' + encodeURIComponent(vipShippingDiscount) + '?redirect=' + encodeURIComponent(returnPath));
    return true;
  }
  function vipProductDiscountIsApplied() {
    var button = doc.querySelector('[data-cr-focus3p-variant-id]');
    var variantId = button && button.getAttribute('data-cr-focus3p-variant-id');
    if (!variantId) return Promise.resolve(false);
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { if (!response.ok) throw new Error('Cart read failed'); return response.json(); })
      .then(function (cart) {
        var quantity = 0;
        var freeQuantity = 0;
        (cart.items || []).forEach(function (item) {
          if (String(item.variant_id) !== String(variantId)) return;
          quantity += Number(item.quantity) || 0;
          if (Number(item.final_line_price) === 0) freeQuantity += Number(item.quantity) || 0;
        });
        return quantity === 3 && freeQuantity === 2;
      })
      .catch(function () { return false; });
  }
  function resumeVipDiscountRedirect() {
    var url = new URL(window.location.href);
    var step = url.searchParams.get('cr-vip-step');
    var pending = readVipDrawerPending();
    if (step === 'shipping') return applyVipShippingCode();
    if (step === 'open-drawer') return openCompletedVipDrawer();
    // Query parameters normally carry the stage. These fallbacks cover Shopify's redirect normalizer,
    // which can return to the page after applying a code without retaining that parameter.
    if (pending === 'shipping') return openCompletedVipDrawer();
    if (pending === 'product') {
      vipProductDiscountIsApplied().then(function (isApplied) {
        if (isApplied) applyVipShippingCode();
      });
      return true;
    }
    return false;
  }
  function addThenApplyVipOffer(id, qty, button) {
    add(id, qty)
      .then(function () { beginVipDiscountRedirect(); })
      .catch(function () {
        setBusy(button, false);
        toast('Could not add the VIP 3-Pack. Please try again.');
      });
  }
  function addVipPack(button) {
    var id = button.getAttribute('data-cr-focus3p-variant-id');
    var qty = Number(button.getAttribute('data-cr-focus3p-quantity')) || 3;
    if (!id) return;
    setBusy(button, true);
    addThenApplyVipOffer(id, qty, button);
  }
  function completeVipPack(button) {
    var id = button.getAttribute('data-cr-vip-add');
    var qty = Number(button.getAttribute('data-cr-vip-need')) || 0;
    if (!id || qty < 1) return;
    button.disabled = true;
    button.textContent = 'Adding…';
    addThenApplyVipOffer(id, qty, button);
  }
  function removeVipPack(button) {
    var keys = (button.getAttribute('data-cr-vip-keys') || '').split('|').filter(Boolean);
    if (!keys.length) return;
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });
    button.disabled = true;
    request('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (cart) {
      return refreshDrawer(cart);
    }).catch(function () {
      button.disabled = false;
      toast('Could not remove the VIP 3-Pack. Please try again.');
    });
  }
  function initVipStickyCta() {
    var sticky = doc.querySelector('[data-cr-focus3p-sticky]');
    var buybox = doc.querySelector('[data-cr-focus3p-buybox]');
    var primary = buybox && buybox.querySelector('[data-cr-focus3p-add]');
    if (!sticky || !primary || sticky.getAttribute('data-cr-focus3p-sticky-ready') === '1') return;
    sticky.setAttribute('data-cr-focus3p-sticky-ready', '1');
    sticky.removeAttribute('hidden');
    var controls = sticky.querySelectorAll('button, a[href], input, select, textarea, [tabindex]');
    function setVisible(visible) {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      doc.body.classList.toggle('cr-vip-stickybar-visible', visible);
      controls.forEach(function (control) {
        if (visible) {
          var previous = control.getAttribute('data-cr-vip-prev-tabindex');
          if (previous === null || previous === '') control.removeAttribute('tabindex');
          else control.setAttribute('tabindex', previous);
          control.removeAttribute('data-cr-vip-prev-tabindex');
          if (control.tagName === 'BUTTON' || control.tagName === 'INPUT' || control.tagName === 'SELECT') control.disabled = false;
        } else {
          if (!control.hasAttribute('data-cr-vip-prev-tabindex')) control.setAttribute('data-cr-vip-prev-tabindex', control.getAttribute('tabindex') || '');
          control.setAttribute('tabindex', '-1');
          if (control.tagName === 'BUTTON' || control.tagName === 'INPUT' || control.tagName === 'SELECT') control.disabled = true;
        }
      });
    }
    function sync() {
      var box = primary.getBoundingClientRect();
      var viewport = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
      setVisible(box.bottom <= 0 || box.top >= viewport);
    }
    setVisible(false);
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { setVisible(!entry.isIntersecting); });
      }, { threshold: 0 });
      observer.observe(primary);
    }
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', sync);
      window.visualViewport.addEventListener('scroll', sync);
    }
    sync();
  }
  // VIP page guard: Dawn's predictive-search component builds a RegExp from the
  // previous query. Escape that query before matching so a shopper's literal text
  // (for example `[`, `(`, or `*`) cannot throw an invalid-regexp error.
  function escapeRegExp(value) {
    return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  function hardenPredictiveSearch() {
    if (!window.customElements || typeof window.customElements.whenDefined !== 'function') return;
    window.customElements.whenDefined('predictive-search').then(function () {
      var SearchElement = window.customElements.get('predictive-search');
      var proto = SearchElement && SearchElement.prototype;
      if (!proto || proto.__crVipPredictiveSearchHardened || typeof proto.updateSearchForTerm !== 'function') return;
      var originalUpdate = proto.updateSearchForTerm;
      proto.updateSearchForTerm = function (previousTerm, newTerm) {
        var searchForText = this.querySelector('[data-predictive-search-search-for-text]');
        var currentButtonText = searchForText && searchForText.innerText;
        if (currentButtonText && previousTerm) {
          if ((currentButtonText.match(new RegExp(escapeRegExp(previousTerm), 'g')) || []).length > 1) return;
          searchForText.innerText = currentButtonText.replace(previousTerm, newTerm);
          return;
        }
        return originalUpdate.call(this, previousTerm, newTerm);
      };
      Object.defineProperty(proto, '__crVipPredictiveSearchHardened', { value: true });
    }).catch(function () {});
  }
  hardenPredictiveSearch();

  initVipStickyCta();
  resumeVipDiscountRedirect();
  doc.addEventListener('click', function (event) {
    var pack = event.target.closest('[data-cr-focus3p-add]');
    if (pack) { event.preventDefault(); addVipPack(pack); return; }
    var nudge = event.target.closest('[data-cr-vip-add]');
    if (nudge) { event.preventDefault(); completeVipPack(nudge); return; }
    var remove = event.target.closest('[data-cr-vip-remove]');
    if (remove) { event.preventDefault(); removeVipPack(remove); }
  });
})();
